const MachineItem = ({machine}) => {
  return machine.type === 'Plotter' ? (
    <div className='relative p-3 bg-teal-400 min-w-[335px] my-2 rounded-md mx-2 shadow-sm shadow-gray-500'>
        <div className="flex absolute -top-1 -left-1 px-3 py-1 shadow-md font-medium bg-blue-500 text-white rounded-full">
            {machine.type}
        </div>
        <div className="flex p-2 items-center justify-center">
            <img src="/gear.png" className={`w-28 p-1 bg-white rounded-full shadow ${parseInt(machine.D7) === 0 && 'animate-spin'}`} alt="machine" />
        </div>
        <div className="flex flex-col">
            <div className='flex justify-between my-1'>
                <span className='bg-blue-500 shadow-sm px-2 py-1 rounded-full font-medium text-gray-50'>Name</span>
                <span className='text-gray-500 bg-white shadow-sm px-2 py-1 rounded-full text-md'>{machine.Name}</span>
            </div>
            <div className='flex justify-between my-1'>
                <span className='bg-blue-500 shadow-sm px-2 py-1 rounded-full font-medium text-gray-50'>Mac Address</span>
                <span className='text-gray-500 bg-white shadow-sm px-2 py-1 rounded-full text-md'>{machine.macAddress}</span>
            </div>
            <div className='flex justify-between my-1'>
                <span className='bg-blue-500 shadow-sm px-2 py-1 rounded-full font-medium text-gray-50'>Power</span>
                <span className='text-gray-500 bg-white shadow-sm px-2 py-1 rounded-full text-md'>{parseInt(machine.D5) === 1 ? 'OFF' : 'ON'}</span>
            </div>
            <div className='flex justify-between my-1'>
                <span className='bg-blue-500 shadow-sm px-2 py-1 rounded-full font-medium text-gray-50'>Status</span>
                <span className='text-gray-500 bg-white shadow-sm px-2 py-1 rounded-full text-md'>{parseInt(machine.D7) === 1 ? 'REST' : 'CUTTING'}</span>
            </div>
            
        </div>
    </div>
  ) : machine.type === 'Embroidery' && (
    <div className='relative p-3 bg-violet-400 min-w-[335px] my-2 rounded-md mx-2 shadow-sm shadow-gray-500'>
        <div className="flex absolute -top-1 -left-1 px-3 py-1 shadow-md font-medium bg-red-500 text-white rounded-full">
            {machine.type}
        </div>
        <div className="flex absolute -top-1 -right-1 px-3 py-1 shadow-md font-medium bg-red-500 text-white rounded-full">
            {machine.HeadNumber}
        </div>
        <div className="flex p-2 items-center justify-center">
            <img src="/gear.png" className={`w-28 p-1 bg-white rounded-full shadow ${parseInt(machine.working) === 1 && 'animate-spin'}`} alt="machine" />
        </div>
        <div className="flex flex-col">
            <div className='flex justify-between my-1'>
                <span className='bg-red-500 shadow-sm px-2 py-1 rounded-full font-medium text-gray-50'>Name</span>
                <span className='text-gray-500 bg-white shadow-sm px-3 py-1 rounded-full text-md'>{machine.Name}</span>
            </div>
            <div className='flex justify-between my-1'>
                <span className='bg-red-500 shadow-sm px-2 py-1 rounded-full font-medium text-gray-50'>Mac Address</span>
                <span className='text-gray-500 bg-white shadow-sm px-2 py-1 rounded-full text-md'>{machine.macAddress}</span>
            </div>
            <div className='flex justify-between my-1'>
                <span className='bg-red-500 shadow-sm px-2 py-1 rounded-full font-medium text-gray-50'>Power</span>
                <span className='text-gray-500 bg-white shadow-sm px-2 py-1 rounded-full text-md'>{parseInt(machine.D5) === 1 ? 'OFF' : 'ON'}</span>
            </div>
            <div className='flex justify-between my-1'>
                <span className='bg-red-500 shadow-sm px-2 py-1 rounded-full font-medium text-gray-50'>Status</span>
                <span className='text-gray-500 bg-white shadow-sm px-2 py-1 rounded-full text-md'>{parseInt(machine.working) !== 1 ? 'REST' : 'CUTTING'}</span>
            </div>
        </div>
    </div>
    )
}

export default MachineItem

// States 
// •	Power ON/OFF
// •	Emb/Rest
// •	start
// •	stop

// Mac Address (120.02220.222)
// Dropdown => (Plotter/embroidery)
// D7 = 2
// D5 = 2
// D2 = 2